import { counterIcon } from './icons';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import counterBlockMeta from './block.json';
import edit from './edit';
import save from './save';
import './style.scss';

const {
  blocks: { registerBlockType },
} = wp;
const { name, ...settings } = counterBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeClassDropDown,
  ...attributeVisibility,
};
registerBlockType(name, {
  ...settings,
  icon: counterIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
